import { TipoSangue } from './TipoSangue';
import { Opm } from './Opm';
import { Obm } from './Obm';
import { Graduacao } from './Graduacao';
import { EstadoCivil } from './EstadoCivil';
import { Bairro } from './Bairro';
export class Socio { 
  id = 0;
  avatar = [];
  diretor = 0;
  dataCadastro = '';
  numeroLancamento = 0;
  cpf = '';
  codigo = '';
  matricula = '';
  nome = '';
  rg = '';
  emissorRg = '';
  dataNascimento = '';
  sexo = '';
  tipoSangue = new TipoSangue();
  opm = new Opm();
  obm = new Obm();
  graduacao = new Graduacao();
  nomeGuerra = '';
  estadoCivil = new EstadoCivil();
  conjuge = '';
  nomeMae = '';
  nomePai = '';
  contaBanco = [];
  bairro = new Bairro();
  cep = '';
  logradouro = '';
  numero = '';
  complemento = '';
  telefones = [];
  emails = [];
  debitoConveniosFixo = [];
  faixa = 0;
  situacao = 0;
  statusCarteira = 'E';
  statusDeferimento = 'A';
  tipo = '';
  limiteCompra = '500';
  tipoSocio = '';
  desligamentos = [];
  cidade = '';
  dataDemissao = Date;
  socioConvenios = [];
  suspenso = null;
  dependentes = [];
  cartaoSus = '';
  quantidadeMesesAdmissao = 0;
  dataIncorporacao = Date;
  nacionalidade = '';
  naturalidade = '';
  diaVencimento = null;
  usoClube = '';
  sangue = '';
}
